import { getOrder } from '../order/get-order';
export const getOrderVouchers = () => { var _a, _b; return (_b = (_a = getOrder()) === null || _a === void 0 ? void 0 : _a.vouchers) !== null && _b !== void 0 ? _b : []; };
//# sourceMappingURL=get-order-vouchers.js.map